import React from "react";
import { ListOrdered, Plus, Pencil, Trash2, Banknote, Timer } from "lucide-react";

export default function ServicesTab({ loading, services, onAddService, onEditService, onDeleteService }) {
  return (
    <div>
      <div className="admin-section-header">
        <h2 className="section-title" style={{ marginBottom: 0 }}>Hizmet Yönetimi</h2>
        <button onClick={onAddService} className="btn-add">
          <Plus />
          Yeni Hizmet
        </button>
      </div>

      {loading ? (
        <div className="admin-empty">
          <ListOrdered />
          <p>Hizmetler yükleniyor...</p>
        </div>
      ) : services.length === 0 ? (
        <div className="admin-empty">
          <ListOrdered />
          <p>Henüz bir hizmet eklenmemiş.</p>
        </div>
      ) : (
        <div>
          {services.map((service) => (
            <div key={service.id} className="admin-service-item">
              <div>
                <div className="admin-service-name">{service.name}</div>
                <div className="admin-service-meta">
                  <span><Banknote /> {service.price} ₺</span>
                  <span><Timer /> {service.duration} dk</span>
                </div>
              </div>
              <div className="admin-service-actions">
                <button onClick={() => onEditService(service)} className="btn-icon">
                  <Pencil />
                </button>
                <button onClick={() => onDeleteService(service.id)} className="btn-icon danger">
                  <Trash2 />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
